import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

interface RelatedMoviesProps {
  list: Movie[];
}

export default function RelatedMovies({ list }: RelatedMoviesProps) {
  if (list.length === 0) return null;

  return (
    <section className="mt-10">
      <div className="mb-5 flex items-center justify-between gap-4">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950">相关推荐</h2>
          <p className="mt-1 text-sm text-foreground-600">基于类型与标签为你匹配的相似影视作品</p>
        </div>
        <Link to="/category" className="flex items-center gap-1 text-sm text-primary-700 hover:text-primary-800 whitespace-nowrap">
          查看更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-3 md:gap-5 lg:grid-cols-4">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}